import { render, staticRenderFns } from "./order-search.vue?vue&type=template&id=71358750&scoped=true"
import script from "./order-search.vue?vue&type=script&lang=js"
export * from "./order-search.vue?vue&type=script&lang=js"
import style0 from "./order-search.vue?vue&type=style&index=0&id=71358750&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "71358750",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/private/workspaces/smart-life/smart-life-admin/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('71358750')) {
      api.createRecord('71358750', component.options)
    } else {
      api.reload('71358750', component.options)
    }
    module.hot.accept("./order-search.vue?vue&type=template&id=71358750&scoped=true", function () {
      api.rerender('71358750', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/Order/order-search.vue"
export default component.exports